import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ReactNotifications } from 'react-notifications-component';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { ScrollToTop, useIsUserAuth } from 'components';
import AdminViewWidget from 'components/layout/AdminViewWidget';
import ErrorFallback from 'components/layout/ErrorFallback';

import 'styles/app.sass';

//pages
import SocketsConnect from 'src/app/SocketsConnect';
import ConfirmOrderPage from 'src/features/ConfirmOrderPage';
import NotFoundRoute from 'src/features/NotFoundRoute';
import NotificationsStore from 'src/features/NotificationsStore';
import Logout from 'src/features/onboarding/containers/Logout';
import MedicoverForgotPassword from 'src/features/onboarding/containers/medicover/MedicoverForgotPassword';
import MedicoverLogin from 'src/features/onboarding/containers/medicover/MedicoverLogin';
import MedicoverResetPassword from 'src/features/onboarding/containers/medicover/MedicoverResetPassword';
import NewMember from 'src/features/onboarding/containers/NewMember';
import OrderApprovalPage from 'src/features/OrderApprovalPage';
import SupplierFormPage from 'src/features/SupplierFormPage';
import SupplierPage from 'src/features/SupplierPage';
import UserArea from 'src/features/userArea';

import { PublicOnlyRoute } from './routes';

const MedicoverAppRouter = () => {
  const isAuth = useIsUserAuth();

  return (
    <Router>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <ScrollToTop />
        <SocketsConnect />
        <NotificationsStore />
        <ReactNotifications />
        <AdminViewWidget />
        <Switch>
          <PublicOnlyRoute
            exact
            path='/'
            component={MedicoverLogin}
          />
          <PublicOnlyRoute
            exact
            path='/forgot-password'
            component={MedicoverForgotPassword}
          />
          <PublicOnlyRoute
            exact
            path='/reset-password/:token'
            component={MedicoverResetPassword}
          />
          <Route
            exact
            path='/supplier-form/:uid'
            component={SupplierFormPage}
          />
          <Route
            exact
            path='/supplier-page/:uid'
            component={SupplierPage}
          />
          <Route
            exact
            path='/confirm-order/:uid'
            component={ConfirmOrderPage}
          />
          <PublicOnlyRoute
            exact
            path='/new-member/:token'
            component={NewMember}
          />
          <PublicOnlyRoute
            exact
            path='/order-approval/:token'
            component={OrderApprovalPage}
          />
          <Route
            path='/logout'
            component={Logout}
          />
          <Route
            path='/404'
            component={NotFoundRoute}
          />
          <UserArea isAuthenticated={isAuth} />
        </Switch>
      </ErrorBoundary>
    </Router>
  );
};

export default MedicoverAppRouter;
